<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h5>注文一覧</h5>
            </div>
            <div class='buttons'>
                <button class='button is-info' @click='download'>ダウンロード</button>
                <button class='button is-primary' @click='deposited'>入金済み</button>
                <button class='button is-primary' @click='done'>完了</button>
                <button class='button is-danger' @click='orderDelete'>削除</button>
            </div>
            <div class='table-container'>
                <table class='table is-striped is-hoverable is-fullwidth'>
                    <thead>
                        <tr>
                            <th class='selectbox'>選択</th>
                            <th class='order_number'>注文番号</th>
                            <th class='name'>お名前</th>
                            <th class='email'>メールアドレス</th>
                            <th class='address'>住所</th>
                            <th class='size'>サイズ</th>
                            <th class='delivery'>配送方法</th>
                            <th class='payment'>決済方法</th>
                            <th class='quantity'>数量</th>
                            <th class='amount'>料金</th>
                            <th class='status'>状態</th>
                            <th class='created_at'>注文日</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for='order in displayOrders' :key='order.id'>
                            <td><input type='checkbox' class='checkbox' :value='order.id' v-model='selectOrders'></td>
                            <td>{{ order.order_number }}</td>
                            <td>{{ order.name }}</td>
                            <td>{{ order.email }}</td>
                            <td>{{ order.address }}</td>
                            <td>{{ order.size }}</td>
                            <td>{{ order.delivery }}</td>
                            <td>{{ order.payment }}</td>
                            <td>{{ order.quantity }}</td>
                            <td>{{ order.amount }}</td>
                            <td>{{ order.status }}</td>
                            <td>{{ order.created_at }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import JSZip from 'jszip'

export default {
    name: 'Order',
    components: {
    },
    data () {
        return {
            orders: [],
            selectOrders: [],
            viewOrderPage: 0
        }
    },
    computed: {
        displayOrders () {
            const self = this

            const array = self.orders.map((x) => {
                if (x.status === 0) x.status = '未決済'
                else if (x.status === 1) x.status = '支払済'
                else if (x.status === 2) x.status = '完了'

                x.created_at = self.getDate(x.created_at)

                return x
            })

            return array.splice(0, (this.viewOrderPage + 1) * 20)
        }
    },
    mounted () {
        const self = this
        const addViewOrders = () => {
            const bottomOfWindow = window.scrollY + window.innerHeight >= document.documentElement.offsetHeight
            if (bottomOfWindow) {
                self.viewOrderPage++
            }
        }
        addViewOrders()
        window.addEventListener('scroll', addViewOrders)

        const params = self.$parent.requestParams

        self.axios.get(`${process.env.API_URL}/lab/order${params}`).then((res) => {
            self.orders = res.data.orders
        }).catch((e) => {
            self.$root.$emit('notification', 'is-danger', 'サーバーエラーが発生しました')
        })
    },
    methods: {
        getDate (x) {
            const date = new Date(x)

            const y = date.getFullYear()
            const m = ('0' + (date.getMonth() + 1)).slice(-2)
            const d = ('0' + date.getDate()).slice(-2)
            const h = ('0' + date.getHours()).slice(-2)
            const mn = ('0' + date.getMinutes()).slice(-2)
            const s = ('0' + date.getSeconds()).slice(-2)

            return `${y}-${m}-${d} ${h}:${mn}:${s}`
        },
        changeStatus () {

        },
        download () {
            const self = this

            if (!self.selectOrders.length) {
                self.$root.$emit('notification', 'is-warning', '注文が選択されていません')
                return
            }

            if (self.selectOrders.length > 1) {
                self.$root.$emit('notification', 'is-warning', '同時にダウンロードできる注文は1つまでです')
                return
            }

            self.axios.post(`${process.env.API_URL}/lab/dpof`, {
                orderId: self.selectOrders[0]
            }).then((res) => {
                const dpofText = res.data.dpofText
                const orderNumber = res.data.orderNumber
                const photos = res.data.photos

                const zip = new JSZip()
                zip.folder('L').folder('MISC').file('AUTPRINT.MRK', dpofText)

                const promises = []

                photos.forEach((photo) => {
                    promises.push(
                        new Promise((resolve, reject) => {
                            self.axios.get(`${process.env.PHOTO_BASE_URL}/${photo.s3_key}`, {
                                'responseType': 'arraybuffer',
                                'headers': {
                                    'Content-Type': 'image/jpeg'
                                }
                            }).then((res) => {
                                resolve({ photo, data: res.data })
                            }).catch(() => {
                                resolve({ photo, data: null })
                            })
                        })
                    )
                })

                Promise.all(promises).then((vals) => {
                    vals.forEach((val) => {
                        zip.folder('$IMG_PRN').file(val.photo.name, val.data)
                    })

                    zip.generateAsync({ type: 'blob' }).then((blob) => {
                        const a = document.createElement('a')
                        var blobUrl = window.URL.createObjectURL(blob)
                        document.body.appendChild(a)
                        a.style = 'display: none'
                        a.href = blobUrl
                        a.download = orderNumber
                        a.click()
                    })
                })
            })
        },
        deposited () {
            const self = this
            const params = this.$parent.requestParams

            if (!self.selectOrders.length) {
                self.$root.$emit('notification', 'is-warning', '注文が選択されていません')
                return
            }

            self.axios.put(`${process.env.API_URL}/lab/order${params}`, {
                status: 1,
                orderIds: self.selectOrders
            }).then((res) => {
                self.orders = res.data.orders
                self.$root.$emit('notification', 'is-success', '処理が完了しました')
            })
        },
        done () {
            const self = this
            const params = this.$parent.requestParams

            if (!self.selectOrders.length) {
                self.$root.$emit('notification', 'is-warning', '注文が選択されていません')
                return
            }

            self.axios.put(`${process.env.API_URL}/lab/order${params}`, {
                status: 2,
                orderIds: self.selectOrders
            }).then((res) => {
                self.orders = res.data.orders
                self.$root.$emit('notification', 'is-success', '処理が完了しました')
            })
        },
        orderDelete () {
            const self = this
            const params = this.$parent.requestParams

            if (!self.selectOrders.length) {
                self.$root.$emit('notification', 'is-warning', '注文が選択されていません')
                return
            }

            self.axios.delete(`${process.env.API_URL}/lab/order${params}`, {
                data: {
                    orderIds: self.selectOrders
                }
            }).then((res) => {
                self.orders = res.data.orders
                self.$root.$emit('notification', 'is-success', '処理が完了しました')
            })
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    padding: 25px;
    margin: auto;
    min-width: 880px;
}

.buttons {
    margin: 0;
}

.buttons > button {
    height: 35px;
}

.quantity, .amount, .status, .selectbox {
    min-width: 60px;
}

.size {
    min-width: 90px;
}

.name, .delivery, .payment, .created_at {
    min-width: 120px;
}

.email {
    min-width: 210px;
}

.address {
    min-width: 320px;
}

th {
    max-width: 300px;
}

.status {
    min-width: 80px;
}

.checkbox {
    width: 20px;
    height: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/lab/pages/Order.vue